<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 pr-4 page-header" ref="pageHeader">
      <div class="row d-flex align-items-center">
        <div class="col">
          <div class="text-nowrap">
            <h4>
              <b-icon class="me-2" icon="card-list"></b-icon>
              Vergabeeinheiten
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- Neue Vergabeeinheit -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              @click="scrollToNewRecordRow"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Vergabeeinheit
            </b-button>
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              @click="createVeCopy"
              :disabled="!isDeleteButtonEnabled"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Kopie
            </b-button>
            <b-button
              :disabled="!isDeleteButtonEnabled"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              size="sm"
              variant="light"
              class="ml-2"
              @click="deleteSelected()"
            >
              <b-icon icon="trash" variant="dark" class="mr-1"></b-icon>
              Löschen
            </b-button>
            <b-button size="sm" variant="light" class="ml-2">
              <b-icon @click="loadAllocationUnits" icon="arrow-repeat" variant="dark" class=""></b-icon>
            </b-button>
            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 mr-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="searchText"
                :class="{ 'bg-primary-light-3': searchText !== '' }"
                placeholder="Suchbegriff eingeben..."
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  -->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              :disabled="!isDeleteButtonEnabled"
              @click="filterRecords"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- COPY TO EXCEL  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              @click="copyToExcel"
              title="In Zwischenablage für Excel kopieren"
            >
              <!-- Custom copy-to-spreadsheet icon: back sheet (copy) + front sheet with table grid -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                aria-hidden="true"
                style="vertical-align: -0.125em"
              >
                <path
                  d="M6 0a1.5 1.5 0 0 0-1.5 1.5V3H6V1.5a.5.5 0 0 1 .5-.5h4v2A1.5 1.5 0 0 0 12 4.5h2v6a.5.5 0 0 1-.5.5H12v1h1.5A1.5 1.5 0 0 0 15 10.5V3.914a1.5 1.5 0 0 0-.44-1.06L12.147.439A1.5 1.5 0 0 0 11.086 0H6zm5.5 1.207L13.293 3H12a.5.5 0 0 1-.5-.5V1.207z"
                />
                <path
                  d="M1.5 5A1.5 1.5 0 0 0 0 6.5v8A1.5 1.5 0 0 0 1.5 16h7A1.5 1.5 0 0 0 10 14.5v-8A1.5 1.5 0 0 0 8.5 5h-7zM1 6.5a.5.5 0 0 1 .5-.5H4v2.25H1V6.5zm4-.5h3.5a.5.5 0 0 1 .5.5v1.75H5V6zM1 9.25h3v2.5H1v-2.5zm4 0h4v2.5H5v-2.5zM1 12.5h3V15H1.5a.5.5 0 0 1-.5-.5v-2zm4 0h4v2a.5.5 0 0 1-.5.5H5v-2.5z"
                />
              </svg>
            </b-button>
            <!-- HELP ICON  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              href="https://www.bauvisor.de/vergabeeinheiten/"
              target="_blank"
            >
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
            <!-- BUTTON: DROPDOWN WEITERE AKTIONEN  -->
            <b-dropdown
              size="sm"
              variant="light"
              toggle-class="text-decoration-none"
              no-caret
              right
              class="ml-2"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <template #button-content>
                <b-icon icon="three-dots-vertical" variant="dark" class="mr-1"></b-icon>
              </template>
              <b-dropdown-item href="#" @click="showImportVEModal">
                <b-icon icon="cloud-upload" class="mr-1" />
                VE aus Excel importieren
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="showCreateVEfromKKEDialog">
                <b-icon icon="files" class="mr-1" />
                VE aus KKE erstellen
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      <div class="row m-0 p-0 mb-4 bg-white" style="border: 1px solid #dee2e6">
        <div class="w-100 py-2 text-muted small" style="border-bottom: 1px solid #dee2e6; padding-left: 13px">
          Übersicht - Aktuelles Budget
        </div>
        <!---------------------------------
            BUDGET SUMMARY SECTION
        ---------------------------------->
        <div class="px-2 w-100 shadow-muted-super" ref="budgetSummarySection">
          <table class="table table-sm table-borderless mb-0" style="table-layout: fixed">
            <tr>
              <td class="align-middle text-muted" style="width: 15%">KKE-Budget:</td>
              <td class="text-right" style="width: 13%">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetKKE) }}
                </div>
              </td>
              <td style="max-width: 4%"></td>
              <td style="border-left: 1px solid #dee2e6; max-width: 4%"></td>
              <td class="align-middle text-muted" style="width: 15%">&nbsp;</td>
              <td class="text-right" style="width: 13%">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetKKESum) }}
                </div>
              </td>
              <td style="max-width: 4%"></td>
              <td style="border-left: 1px solid #dee2e6; max-width: 4%"></td>
              <td class="align-middle text-muted" style="width: 15%">&nbsp;</td>
              <td class="text-right" style="width: 13%">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetKKE - this.budgetKKESum) }}
                </div>
              </td>
            </tr>
            <tr style="border-bottom: 4px double #dee2e6">
              <td class="align-middle text-muted">PÄT-Budget:</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetPAT) }}
                </div>
              </td>
              <td></td>
              <td style="border-left: 1px solid #dee2e6"></td>
              <td class="align-middle">&nbsp;</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetPATSum) }}
                </div>
              </td>
              <td></td>
              <td style="border-left: 1px solid #dee2e6"></td>
              <td class="align-middle">&nbsp;</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1">
                  {{ formatCurrency(this.budgetPAT - this.budgetPATSum) }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="align-middle font-weight-bold text-muted" style="width: 20%">Gesamtbudget:</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1 font-weight-bold">
                  {{ formatCurrency(this.budgetKKE + this.budgetPAT) }}
                </div>
              </td>
              <td></td>
              <td style="border-left: 1px solid #dee2e6"></td>
              <td class="align-middle font-weight-bold text-muted">&nbsp;Zugewiesen</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1 font-weight-bold">
                  {{ formatCurrency(this.budgetKKESum + this.budgetPATSum) }}
                </div>
              </td>
              <td></td>
              <td style="border-left: 1px solid #dee2e6"></td>
              <td class="align-middle font-weight-bold text-muted">&nbsp;Freie Mittel:</td>
              <td class="text-right">
                <div class="bg-light m-0 p-1 font-weight-bold">
                  {{ formatCurrency(this.budgetKKE - this.budgetKKESum + (this.budgetPAT - this.budgetPATSum)) }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="table-sticky-header-hack"></div>
      <b-form ref="newRecordRowForm" id="newRecordRowForm">
        <b-table
          :filter="searchText"
          small
          bordered
          hover
          :sticky-header="tableHeight"
          class="bg-white allocationUnitsTable sum-header shadow-muted-super"
          :items="allocationUnits"
          :fields="visibleFields"
          head-variant="light"
          show-empty
          :busy="tableIsBusy"
          ref="allocationUnitsTable"
          :responsive="true"
          :no-local-sorting="true"
          :sort-by.sync="sortField"
          :sort-desc.sync="sortDirection"
          @sort-changed="onSortChanged"
          @filtered="handleFilterChange"
        >
          <template #empty>
            <div class="block text-center text-muted p-5">Keine Vergabeeinheiten vorhanden.</div>
          </template>

          <template #head(checked)>
            <b-form-checkbox
              class="ml-2"
              :disabled="allocationUnits.length == 0"
              v-model="checkedAllTableEntries"
              @change="onCheckAllTableEntries"
            ></b-form-checkbox>
          </template>
          <!--
          <template #head(DisplayName)="data">
            <div style="width: 600px">{{ data.label }}</div>
          </template>
          -->
          <template #head(BudgetSaldo)="data">
            <div style="padding-right: 11px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(allocationUnitsTotal) }}
            </div>
          </template>
          <template #head(FA1)>
            {{ settingsStore.settings['FA1'] }}
          </template>
          <template #head(FA2)>
            {{ settingsStore.settings['FA2'] }}
          </template>

          <template #cell(checked)="data">
            <b-form-checkbox
              class="ml-2"
              @change="onCheckedItemChange(data.item)"
              v-model="data.item.checked"
              :disabled="data.item.editMode"
            ></b-form-checkbox>
          </template>
          <template #cell(Ordinal)="data">
            <div
              class=""
              style="
                padding-left: 5px;
                padding-right: 5px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              "
              v-show="!data.item.editMode"
              @click="toggleRowEdit(data.item, 'ordinalField')"
            >
              {{ data.item.Ordinal }}
            </div>
            <input
              :required="data.item.editMode"
              v-show="data.item.editMode"
              v-model.lazy="data.item.Ordinal"
              class="form-control table-input-field px-1"
              :ref="'ordinalField-' + data.item.DbId"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              maxlength="50"
            />
          </template>
          <template #cell(DisplayName)="data">
            <div
              style="padding-left: 5px; padding-right: 5px; max-width: 500px; word-wrap: break-word"
              v-show="!data.item.editMode"
              @click="toggleRowEdit(data.item, 'displayNameField')"
            >
              {{ data.item.DisplayName }}
            </div>
            <input
              :required="data.item.editMode"
              class="form-control table-input-field px-1"
              v-show="data.item.editMode"
              v-model.lazy="data.item.DisplayName"
              :ref="'displayNameField-' + data.item.DbId"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              maxlength="100"
            />
          </template>
          <template #cell(BudgetSaldo)="data">
            <div
              style="padding-left: 5px"
              :class="{ 'action-button': !data.item.editMode }"
              @click="navigateTo(data.item)"
            >
              {{ formatCurrency(data.item.BudgetTotal) }}
            </div>
          </template>
          <template #cell(KGR)="data">
            <div style="padding-left: 5px" v-show="!data.item.editMode" @click="toggleRowEdit(data.item, 'kgrField')">
              {{ data.item.KGR != null && data.item.KGR != '' ? data.item.KGR : '&nbsp;' }}
            </div>
            <input
              class="form-control table-input-field px-1"
              :ref="'kgrField-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model.lazy="data.item.KGR"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              v-if="settingsStore.settings['KGR_Mode'] == 'F'"
            />
            <b-form-select
              :ref="'kgrField-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model="data.item.KGR"
              :options="settingsStore.settingsParsed['KGR_Selections_Parsed']"
              class="border-0 shadow-none table-input-field"
              id="input-select-1"
              placeholder="Kostengruppe"
              v-if="settingsStore.settings['KGR_Mode'] == 'S'"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @blur.native="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>
          <template #cell(Responsible)="data">
            <div
              style="padding-left: 5px"
              v-show="!data.item.editMode"
              @click="toggleRowEdit(data.item, 'reponsibleField')"
            >
              {{ data.item.Responsible != null && data.item.Responsible != '' ? data.item.Responsible : '&nbsp;' }}
            </div>
            <input
              :ref="'reponsibleField-' + data.item.DbId"
              class="form-control table-input-field px-1"
              v-show="data.item.editMode"
              v-model.lazy="data.item.Responsible"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              v-if="settingsStore.settings['Responsible_Mode'] == 'F'"
            />
            <b-form-select
              :ref="'reponsibleField-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model="data.item.Responsible"
              :options="settingsStore.settingsParsed['Responsible_Selections_Parsed']"
              class="border-0 shadow-none table-input-field"
              id="input-select-1"
              placeholder="Kostengruppe"
              v-if="settingsStore.settings['Responsible_Mode'] == 'S'"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @blur.native="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>
          <template #cell(FA1)="data">
            <div style="padding-left: 5px" v-if="!data.item.editMode" @click="toggleRowEdit(data.item, 'fa1Field')">
              {{ data.item.FA1 != null && data.item.FA1.trim() != '' ? data.item.FA1 : '&nbsp;' }}
            </div>
            <input
              :ref="'fa1Field-' + data.item.DbId"
              class="form-control table-input-field px-1"
              v-show="data.item.editMode"
              v-model.lazy="data.item.FA1"
              @keydown.esc.stop.prevent="cancelRowEdit(data.item)"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              v-if="settingsStore.settings['FA1_Mode'] == 'F'"
            />
            <b-form-select
              :ref="'fa1Field-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model="data.item.FA1"
              :options="settingsStore.settingsParsed['FA1_Selections_Parsed']"
              class="border-0 shadow-none table-input-field"
              id="input-select-1"
              placeholder="Kostengruppe"
              v-if="settingsStore.settings['FA1_Mode'] == 'S'"
              @keydown.esc.stop.prevent="cancelRowEdit(data.item)"
              @blur.native="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>
          <template #cell(FA2)="data">
            <div style="padding-left: 5px" v-show="!data.item.editMode" @click="toggleRowEdit(data.item, 'fa2Field')">
              {{ data.item.FA2 != null && data.item.FA2.trim() != '' ? data.item.FA2 : '&nbsp;' }}
            </div>
            <input
              :ref="'fa2Field-' + data.item.DbId"
              class="form-control table-input-field px-1"
              v-show="data.item.editMode"
              v-model.lazy="data.item.FA2"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keydown.tab.prevent.stop="$refs['ordinalField-' + data.item.DbId].focus()"
              @keyup.enter="updateAllocationItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              v-if="settingsStore.settings['FA2_Mode'] == 'F'"
            />
            <b-form-select
              :ref="'fa2Field-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model="data.item.FA2"
              :options="settingsStore.settingsParsed['FA2_Selections_Parsed']"
              class="border-0 shadow-none table-input-field"
              id="input-select-1"
              placeholder="Kostengruppe"
              v-if="settingsStore.settings['FA2_Mode'] == 'S'"
              @keydown.esc.stop.prevent="cancelRowEdit(data.item)"
              @blur.native="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>
          <template #cell(StatusText)="data">
            <div style="padding-left: 5px" v-show="!data.item.editMode" @click="toggleRowEdit(data.item, 'statusText')">
              {{ data.item.StatusText }}
            </div>
            <!-- <smalL>{{ data.item.Status }}-{{ data.item.ProcessStatus }}</smalL> -->
            <b-form-select
              :ref="'statusText-' + data.item.DbId"
              v-show="data.item.editMode"
              v-model="data.item.Status"
              :options="[
                {
                  value: 1,
                  text:
                    data.item.Status == 1
                      ? data.item.ProcessStatus == 'entfällt'
                        ? 'zurücksetzen'
                        : data.item.ProcessStatus
                      : 'zurücksetzen'
                },
                { value: 2, text: 'entfällt' }
              ]"
              class="border-0 shadow-none table-input-field"
              @keyup.esc.stop.prevent="cancelRowEdit(data.item)"
              @keydown.tab.native.stop.prevent="$refs['ordinalField-' + data.item.DbId].focus()"
              @blur.native="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>
          <template #custom-foot="">
            <!---------------------------------
                    NEW RECORD ROW
                ---------------------------------->
            <b-tr
              style="border-top: 2px solid #dee2e6; border-bottom: 2px solid #dee2e6"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <b-td class="py-0 align-middle table-edit-field" style="padding-left: 14px">
                <b-icon
                  icon="plus-circle"
                  variant="grey"
                  class="action-button"
                  @click="$refs.newRecordRowFirstField.focus()"
                />
              </b-td>
              <b-td class="p-0">
                <!-- FELD "VE" -->
                <b-input
                  placeholder="VE"
                  type="text"
                  name="VE"
                  class="border-0 shadow-none table-edit-field px-1"
                  v-model.lazy="rowDataNewRecord.Ordinal"
                  ref="newRecordRowFirstField"
                  required
                  @keyup.enter="insertNewRecord"
                  maxlength="50"
                />
              </b-td>
              <b-td class="p-0">
                <!-- FELD: BEZEICHNUNG  -->
                <b-input
                  placeholder="Bezeichnung"
                  name="Bezeichnung"
                  type="text"
                  class="border-0 shadow-none table-edit-field px-1"
                  v-model.lazy="rowDataNewRecord.DisplayName"
                  required
                  @keyup.enter="insertNewRecord"
                  maxlength="100"
                />
              </b-td>
              <b-td class="text-right align-middle py-0 bg-light text-muted">{{ formatCurrency(0.0) }}</b-td>
              <b-td class="py-0 align-middle bg-light text-muted">Offen</b-td>
              <b-td class="p-0" v-if="settingsStore.settings['KGR_Selections_Active'] == 'true'">
                <!-- FELD: KOSTENGRUPPE  -->
                <b-input
                  placeholder="Kostengruppe"
                  name="Kostengruppe"
                  type="text"
                  class="border-0 shadow-none table-edit-field"
                  v-model.lazy="rowDataNewRecord.KGR"
                  @keyup.enter="insertNewRecord"
                  v-if="settingsStore.settings['KGR_Mode'] == 'F'"
                />
                <b-form-select
                  v-model="rowDataNewRecord.KGR"
                  :options="settingsStore.settingsParsed['KGR_Selections_Parsed']"
                  class="border-0 shadow-none table-edit-field"
                  id="input-select-1"
                  placeholder="Kostengruppe"
                  v-if="settingsStore.settings['KGR_Mode'] == 'S'"
                />
              </b-td>
              <b-td class="p-0" v-if="settingsStore.settings['Responsible_Selections_Active'] == 'true'">
                <!-- FELD: VERANTWORTLICH -->
                <b-input
                  placeholder="Verantwortlich"
                  name="Verantwortlich"
                  type="text"
                  class="border-0 shadow-none table-edit-field"
                  v-model.lazy="rowDataNewRecord.Responsible"
                  @keyup.enter="insertNewRecord"
                  v-if="settingsStore.settings['Responsible_Mode'] == 'F'"
                />
                <b-form-select
                  v-model="rowDataNewRecord.Responsible"
                  :options="settingsStore.settingsParsed['Responsible_Selections_Parsed']"
                  class="border-0 shadow-none table-edit-field"
                  id="input-select-1"
                  placeholder="Verantwortlich"
                  v-if="settingsStore.settings['Responsible_Mode'] == 'S'"
                />
              </b-td>
              <b-td class="p-0" v-if="settingsStore.settings['FA1_Active'] == 'true'">
                <!-- FELD: Freies Attribut 1  -->
                <b-input
                  placeholder="Freies Attribut 1"
                  name="FA1"
                  type="text"
                  class="border-0 shadow-none table-edit-field"
                  v-model.lazy="rowDataNewRecord.FA1"
                  @keyup.enter="insertNewRecord"
                  v-if="settingsStore.settings['FA1_Mode'] == 'F'"
                />
                <b-form-select
                  v-model="rowDataNewRecord.FA1"
                  :options="settingsStore.settingsParsed['FA1_Selections_Parsed']"
                  class="border-0 shadow-none table-edit-field"
                  id="input-select-1"
                  placeholder="Verantwortlich"
                  v-if="settingsStore.settings['FA1_Mode'] == 'S'"
                />
              </b-td>

              <b-td class="p-0" v-if="settingsStore.settings['FA2_Active'] == 'true'">
                <!-- FELD: Freies Attribut 2  -->
                <b-input
                  placeholder="Freies Attribut 2"
                  name="FA2"
                  type="text"
                  class="border-0 shadow-none table-edit-field"
                  v-model.lazy="rowDataNewRecord.FA2"
                  @keyup.enter="insertNewRecord"
                  @keydown.tab.stop="$refs.newRecordRowFirstField.focus()"
                  v-if="settingsStore.settings['FA2_Mode'] == 'F'"
                />
                <b-form-select
                  v-model="rowDataNewRecord.FA2"
                  :options="settingsStore.settingsParsed['FA2_Selections_Parsed']"
                  class="border-0 shadow-none table-edit-field"
                  id="input-select-1"
                  placeholder="Verantwortlich"
                  v-if="settingsStore.settings['FA2_Mode'] == 'S'"
                />
              </b-td>
              <!---------------------------------
                    NEW RECORD ROW - ADD NOW BUTTON
                  ---------------------------------->
              <b-td class="p-0 text-center align-middle table-edit-field">
                <b-icon icon="check2" variant="grey" class="action-button" @click="insertNewRecord" />
              </b-td>
            </b-tr>

            <b-tr ref="rowTotalBudget">
              <!--
              <b-td>xxx</b-td>
              <b-td class="text-right" colspan="2">Gesamtbudget:</b-td>
              <b-td class="text-right font-weight-bold">{{ formatCurrency(allocationUnitsTotal) }}</b-td>
            -->
              <b-td colspan="3">
                <span class="float-right">Gesamtbudget:</span>
                <div class="text-muted small " style="margin-left:9px; margin-top:2px;" v-if="!tableIsBusy">
                  {{ displayedItemsCount }} Zeilen dargestellt, {{ selectedRows.length }} Zeilen ausgewählt.
                </div>
              </b-td>
              <b-td class="text-right font-weight-bold">{{ formatCurrency(allocationUnitsTotal) }}</b-td>
            </b-tr>
          </template>
          <template #cell(actions)="data">
            <svg
              v-show="!data.item.editMode"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              class="mr-2 text-grey action-button"
              viewBox="0 0 16 16"
              style="margin-bottom: 2px"
              @click.stop="navigateTo(data.item)"
            >
              <path
                d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"
              />
            </svg>
            <b-icon
              v-show="!data.item.editMode"
              icon="pencil"
              class="mr-2 action-button"
              variant="grey"
              title="Bearbeiten"
              @click.stop="toggleRowEdit(data.item)"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            ></b-icon>
            <b-icon
              v-show="!data.item.editMode"
              title="Löschen"
              icon="trash"
              variant="grey"
              class="action-button"
              @click.stop="deleteAllocationItem(data.item)"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            ></b-icon>
            <b-icon
              v-show="data.item.editMode"
              title="Bearbeiten"
              icon="check2"
              variant="grey"
              class="action-button mr-2"
              @click.stop="updateAllocationItem(data.item)"
            ></b-icon>
            <b-icon
              v-show="data.item.editMode"
              title="Bearbeiten abbrechen"
              icon="x"
              variant="grey"
              class="action-button"
              @click.stop.prevent="cancelRowEdit(data.item)"
            ></b-icon>
          </template>
        </b-table>
      </b-form>
    </div>
    <!------------------------
          MODAL DIALOGS
    -------------------------->
    <NewAllocationUnitModal @success="loadAllocationUnits" @error="$showError" />
    <ImportVEModal @success="loadAllocationUnits" />
    <CreateFromKKEDialog @ok="createVEFromKKE" />
  </div>
</template>

<script>
import projectStore from '@/store/Projects';
import settingsStore from '@/store/Settings';
import allocationUnitsService from '@/service/AllocationUnitsService';
import budgetService from '@/service/BudgetService';
import NewAllocationUnitModal from '@/components/budget/NewAllocationUnitDialog';
import ImportVEModal from '@/components/vergabeeinheiten/ImportVEDialog';
import CreateFromKKEDialog from '@/components/vergabeeinheiten/CreateFromKKEDialog';
import AppState from '@/store/App.js';
import { copyTableToClipboard } from '@/utils/tableExport';

export default {
  components: {
    NewAllocationUnitModal,
    ImportVEModal,
    CreateFromKKEDialog
  },
  data() {
    return {
      selectedRows: [],
      displayedItemsCount: null,
      sortField: null,
      sortDirection: false, // false means ascending
      filterToggle: false,
      rowIsDirty: null,
      projectStore,
      settingsStore,
      allocationUnits: [],
      filteredAllocationUnits: [],
      allocationUnitsFields: [
        {
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'text-center align-middle',
          thClass: 'text-center align-top noselect',
          thStyle: 'width: 50px;'
        },
        {
          visible: true,
          key: 'Ordinal',
          label: 'VE',
          thStyle: 'width:100px;',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'DisplayName',
          label: 'Bezeichnung',
          thStyle: 'min-width:300px;',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'BudgetSaldo',
          label: 'VE-Budget',
          tdClass: 'text-right align-middle',
          thClass: 'align-top text-right noselect',
          thStyle: 'min-width:200px;padding-right: 5px;',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true,
          sortType: 'number'
        },
        {
          visible: true,
          key: 'StatusText',
          label: 'Status',
          thClass: 'align-top noselect',
          thStyle: 'min-width:125px',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'KGR',
          label: 'Kostengruppe',
          thStyle: 'min-width:150px;',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'Responsible',
          label: 'Verantwortlich',
          thStyle: 'min-width:150px;',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'FA1',
          label: settingsStore.settings['FA1'],
          thStyle: 'min-width:150px;',
          thClass: 'align-top noselect ',
          tdClass: 'align-middle p-0 ',
          sortable: true
        },
        {
          visible: true,
          key: 'FA2',
          label: settingsStore.settings['FA2'],
          thStyle: 'min-width:150px;',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          visible: true,
          key: 'Actions',
          label: 'Aktionen',
          tdClass: 'text-center align-middle',
          thStyle: 'min-width: 90px',
          thClass: 'align-top noselect'
        }
      ],
      checkedAllTableEntries: false,
      tableIsBusy: false,
      tableHeight: '500px',
      allocationUnitsTotal: 0,
      rowDataNewRecord: {
        Ordinal: '',
        DisplayName: '',
        KGR: '',
        Responsible: ''
      },
      isDeleteButtonEnabled: false,
      searchText: '',
      budgetKKESum: 0.0,
      budgetPATSum: 0.0,
      budgetKKE: 0.0,
      budgetPAT: 0.0
    }; // end data()
  },
  methods: {
    handleFilterChange(visibleItems) {
      // remove check from all non-visible fields
      const checkItems = this.allocationUnits.filter(x => x.checked == true);
      checkItems.forEach(item => {
        if (visibleItems.findIndex(x => x.DbId == item.DbId) == -1) {
          item.checked = false;
          // also remove from selected rows
          const index = this.selectedRows.findIndex(x => x.DbId == item.DbId);
          if (index != -1) {
            this.selectedRows.splice(index, 1);
          }
        }
      });
      // are all visible rows checked, then also check the "check all" checkbox
      let allChecked = true;
      visibleItems.forEach(item => {
        if (item.checked != true) allChecked = false;
      });
      this.checkedAllTableEntries = visibleItems.length > 0 && allChecked;

      this.filteredAllocationUnits = visibleItems;
      this.recalcAllocationUnitsSum(visibleItems);
    },
    async copyToExcel() {
      // Export the currently displayed rows (search filter applied) in the current sort order.
      const items = this.searchText ? this.filteredAllocationUnits : this.allocationUnits;
      try {
        await copyTableToClipboard(this.visibleFields, items);
        this.$showSuccess(
          this,
          'Excel-Export',
          items.length + ' Zeile(n) in die Zwischenablage kopiert.',
          'b-toaster-top-center'
        );
      } catch (error) {
        this.$showError(this, error.toString());
      }
    },
    onSortChanged(field) {
      // if field is not sortable, do nothing!
      if (!this.visibleFields.find(x => x.key == field.sortBy).sortable) return;
      this.sortTableItemsBy(
        this.allocationUnits,
        field.sortBy,
        field.sortDesc ? 'desc' : 'asc',
        field.sortBy == 'BudgetSaldo' ? 'number' : null
      );
    },
    handleCellLeave(e) {
      console.log('zzz e', e);
      //if (!e.relatedTarget) this.toggleRowEdit(this.rowIsDirty);
    },
    loadAllocationUnits() {
      this.tableIsBusy = true;
      allocationUnitsService
        .getAllocationUnitsWithQuotes(projectStore.activeProject.DbId)
        .then(items => {
          var allChecked = items.length > 0;
          this.allocationUnits = items.map(x => {
            x.editMode = false;
            x.checked = false;
            x.checked = this.selectedRows.find(y => y.DbId == x.DbId) != null;
            if (x.checked !== true) allChecked = false;
            return x;
          });
          if (this.filterToggle) {
            allChecked = true;
            this.allocationUnitsBackup = [...this.allocationUnits];
            this.allocationUnits = this.allocationUnits.filter(x => {
              return x.checked == true;
            });
          }
          this.recalcAllocationUnitsSum();
          this.checkedAllTableEntries = allChecked;
        })
        .catch(error => this.$showError(this, error.toString()))
        .finally(() => {
          if (this.sortField)
            this.sortTableItemsBy(
              this.allocationUnits,
              this.sortField,
              this.sortDirection ? 'desc' : 'asc',
              this.sortField == 'BudgetSaldo' ? 'number' : null
            );
          this.tableIsBusy = false;
          this.$nextTick(() => {
            //this.$refs.allocationUnitsTable.$el.scrollTo({ top: AppState.allocationUnitsTableScrollPosition });
            if (AppState.scrollPosition[this.$route.path])
              this.$refs.allocationUnitsTable.$el.scrollTo({
                top: AppState.scrollPosition[this.$route.path][0],
                left: AppState.scrollPosition[this.$route.path][1]
              });
          });
        });
      budgetService
        .getSummary()
        .then(summary => {
          this.budgetKKE = parseFloat(summary.KkeBudgetSummary);
          this.budgetPAT = parseFloat(summary.PatBudgetSummary);
        })
        .catch(err => console.log(err.toString()));
    },
    createVeCopy() {
      this.tableIsBusy = true;
      const selectedItems = this.allocationUnits.filter(x => x.checked); // get the selected items first
      // run through the selected items and create a copy for each
      selectedItems.forEach(item => {
        const newItem = { ...item };
        for (;;) {
          newItem.DisplayName += ' (1)';
          newItem.Ordinal += ' (1)';
          const alreadyExistingItem = this.allocationUnits.find(
            x => x.Ordinal == newItem.Ordinal || x.DisplayName == newItem.DisplayName
          );
          if (!alreadyExistingItem) break;
        }
        delete newItem.BudgetTotal;
        delete newItem.BudgetSaldo;
        newItem.StatusText = 'Offen';

        allocationUnitsService.createNewAllocationUnit(projectStore.activeProject.DbId, newItem, (err, result) => {
          if (err) {
            if (err.response) {
              this.$showError(this, err.response.data.error);
            } else {
              this.$showError(this, err.toString());
            }
          } else {
            this.$showSuccess(this, 'Vergabeeinheit anlegen', 'Vergabeeinheit erfolgreich angelegt.');
            this.addNewAllocationUnit(result);
            this.$nextTick(() => {
              this.scrollToNewRecordRow();
            });
          }
          selectedItems.forEach(item => {
            item.checked = false;
          });
          this.tableIsBusy = false;
        });
      });
      this.isDeleteButtonEnabled = false;
      this.checkedAllTableEntries = false;
    },
    updateAllocationItem(item) {
      const input = this.$refs['ordinalField-' + item.DbId];
      // ordinals must be unique: do we already have that ordinal?
      for (const otherItem of this.allocationUnits) {
        if (otherItem.Ordinal == item.Ordinal && otherItem.DbId != item.DbId) {
          input.setCustomValidity('VE muss eindeutig sein');
          input.reportValidity();
          return;
        }
      }

      return allocationUnitsService
        .updateAllocationUnit(item)
        .then(returnedItem => {
          item.editMode = false;
          item.StatusText = returnedItem.StatusText;
          item.ProcessStatus = returnedItem.ProcessStatus;
          item.Status = returnedItem.Status;
          this.$showSuccess(
            this,
            'Vergabeeinheit bearbeiten',
            'Vergabeeinheit "' + returnedItem.Ordinal + ' ' + returnedItem.DisplayName + '" erfolgreich aktualisiert.'
          );
          this.recalcAllocationUnitsSum();
          this.visibleFields
            .filter(x => x.sortable !== null)
            .map(x => {
              x.sortable = !item.editMode;
              return x;
            });
          if (this.sortField)
            this.sortTableItemsBy(
              this.allocationUnits,
              this.sortField,
              this.sortDirection ? 'desc' : 'asc',
              this.sortField == 'BudgetSaldo' ? 'number' : null
            );
        })
        .catch(err => this.$showError(this, err.toString()));
    },
    async deleteAllocationItem(item) {
      const objects = await allocationUnitsService.hasObjects(item.DbId);
      const hasObjects =
        objects.orders > 0 ||
        objects.addendums > 0 ||
        objects.kkeallocations > 0 ||
        objects.patallocations > 0 ||
        objects.risks > 0 ||
        objects.invoices > 0;
      if (hasObjects) {
        let questionText = 'Die Vergabeeinheit kann aus folgendem Grund nicht gelöscht werden:<br><br>';
        if (objects.kkeallocations > 0) questionText += '<li class="ml-3">Budgetzuordnungen (KKE) vorhanden</li>';
        if (objects.patallocations > 0) questionText += '<li class="ml-3">Budgetzuordnungen (PÄT) vorhanden</li>';
        if (objects.orders > 0) questionText += '<li class="ml-3">Aufträge vorhanden</li>';
        if (objects.addendums > 0) questionText += '<li class="ml-3">Nachträge vorhanden</li>';
        if (objects.invoices > 0) questionText += '<li class="ml-3">Belege vorhanden</li>';
        if (objects.risks > 0) questionText += '<li class="ml-3">Chancen oder Risiken vorhanden</li>';
        questionText += '<br>Bitte löschen Sie zunächst diese Objekte, bevor die Vergabeeinheit gelöscht werden kann.';

        const messageVNode = this.$createElement('div', { domProps: { innerHTML: questionText } });

        return this.$bvModal.msgBoxOk([messageVNode], {
          title: 'Vergabeeinheit löschen',
          okTitle: 'OK',
          okVariant: 'danger',

          centered: true
        });
      }
      this.$bvModal
        .msgBoxConfirm(
          'Soll die Vergabeeinheit "' + item.Ordinal + ' ' + item.DisplayName + '" wirklich gelöscht werden?',
          {
            title: 'Vergabeeinheit löschen',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            allocationUnitsService.deleteAllocationUnit(projectStore.activeProject.DbId, item.DbId, err => {
              if (err) {
                console.log('zzz', err);
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
                return;
              }
              //this.$utils.deleteItemFromArray(this.allocationUnits, x => x.DbId == item.DbId);
              this.loadAllocationUnits();
              this.$showSuccess(this, 'Vergabeeinheit löschen', 'Vergabeeinheit erfolgreich gelöscht');
            });
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        });
    },
    async deleteSelected() {
      const itemsToDelete = this.allocationUnits.filter(x => {
        return x.checked;
      });

      if (itemsToDelete.length == 1) {
        return this.deleteAllocationItem(itemsToDelete[0]);
        /*
        const objects = await allocationUnitsService.hasObjects(itemsToDelete[0].DbId);
        const hasObjects =
          objects.orders > 0 ||
          objects.addendums > 0 ||
          objects.kkeallocations > 0 ||
          objects.patallocations > 0 ||
          objects.invoices > 0;
        if (hasObjects) {
          let questionText = 'Die Vergabeeinheit kann aus folgendem Grund nicht gelöscht werden:<br><br>';
          if (objects.kkeallocations > 0) questionText += '<li class="ml-3">Budgetzuordnungen (KKE) vorhanden</li>';
          if (objects.patallocations > 0) questionText += '<li class="ml-3">Budgetzuordnungen (PÄT) vorhanden</li>';
          if (objects.orders > 0) questionText += '<li class="ml-3">Aufträge vorhanden</li>';
          if (objects.addendums > 0) questionText += '<li class="ml-3">Nachträge vorhanden</li>';
          if (objects.invoices > 0) questionText += '<li class="ml-3">Belege vorhanden</li>';
          questionText +=
            '<br>Bitte löschen Sie zunächst diese Objekte, bevor die Vergabeeinheit gelöscht werden kann.';

          const messageVNode = this.$createElement('div', { domProps: { innerHTML: questionText } });

          return this.$bvModal.msgBoxOk([messageVNode], {
            title: 'Vergabeeinheit löschen',
            okTitle: 'OK',
            okVariant: 'danger',

            centered: true
          });
        }
        message = 'Sollen die ausgewählte Vergabeeinheiten wirklich gelöscht werden?';*/
      } else {
        const idList = itemsToDelete.map(x => x.DbId);

        const objects = await allocationUnitsService.hasObjectsList(idList);
        var hasObjects = false;
        let messageText =
          'Die nachfolgenden Vergabeeinheiten können nicht gelöscht werden, da Budgetzuordnungen, Aufträge, Belege oder Risken bestehen:<br><br>';
        for (let item of objects) {
          if (
            item.orders > 0 ||
            item.addendums > 0 ||
            item.kkeallocations > 0 ||
            item.patallocations > 0 ||
            item.invoices > 0 ||
            item.risks > 0
          ) {
            hasObjects = true;
            messageText += '<li>' + item.Ordinal + ' ' + item.DisplayName + '</li>';
          }
        }
        if (hasObjects) {
          const messageVNode = this.$createElement('div', { domProps: { innerHTML: messageText } });

          return this.$bvModal.msgBoxOk([messageVNode], {
            title: 'Vergabeeinheit löschen',
            okTitle: 'OK',
            okVariant: 'danger',

            centered: true
          });
        }
      }
      let message = 'Sollen die ausgewählten ' + itemsToDelete.length + ' Vergabeeinheiten wirklich gelöscht werden?';
      this.$bvModal
        .msgBoxConfirm(message, {
          title: 'Vergabeeinheit löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.tableIsBusy = true;

            let idsToDelete = itemsToDelete.map(x => x.DbId);

            allocationUnitsService
              .deleteAllocationUnits(idsToDelete)
              .then(response => {
                if (response.errorCount > 0) {
                  if (response.errorCount == itemsToDelete.length) {
                    this.$showError(
                      this,
                      //'Die Vergabeeinheiten konnten aufgrund von Budgetverletzungen nicht gelöscht werden.'
                      'Die Vergabeeinheiten konnte nicht gelöscht werden, da Budgetzuordnungen oder Aufträge bestehen.'
                    );
                  } else {
                    this.$showWarning(
                      this,
                      'Einige Vergabeeinheiten konnte nicht gelöscht werden, da Budgetzuordnungen oder Aufträge bestehen.'
                    );
                    this.loadAllocationUnits();
                  }
                } else
                  this.$showSuccess(
                    this,
                    'Vergabeeinheiten löschen',
                    itemsToDelete.length + ' Vergabeeinheiten erfolgreich gelöscht.'
                  );
                this.loadAllocationUnits();
              })
              .catch(err => {
                this.$showError(this, 'Vergabeeinheit löschen', err.toString());
              })
              .finally(() => {
                this.recalcAllocationUnitsSum();
                this.tableIsBusy = false;
                this.checkedAllTableEntries = false;
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    scrollToNewRecordRow(focus = false) {
      if (focus) this.$refs.newRecordRowFirstField.$el.focus({ preventScroll: true });
      var element = document.querySelector('.b-table-sticky-header');
      element.scrollBy({
        top: 5000000, // Scroll the the end of the tabele's height
        behavior: 'smooth'
      });
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    recalcAllocationUnitsSum(items) {
      if (!items) items = this.allocationUnits;
      this.allocationUnitsTotal = 0;
      this.budgetKKESum = 0.0;
      this.budgetPATSum = 0.0;
      items.map(x => {
        this.allocationUnitsTotal += x.BudgetSaldo == null ? 0 : parseFloat(x.BudgetSaldo);

        this.budgetKKESum += x.BudgetKKE == null ? 0 : parseFloat(x.BudgetKKE);
        this.budgetPATSum += x.BudgetPAT == null ? 0 : parseFloat(x.BudgetPAT);

        if (x.StatusText == 'offen') {
          if (x.ProcessStatus) {
            x.StatusText = x.ProcessStatus;
          }
        }
      });
      this.displayedItemsCount = items.length;
    },
    navigateTo(item) {
      if (item.editMode) return; // cancel navigation, if item is in edit mode
      this.$router.push('/allocationunits/' + item.DbId);
    },
    updateSelectedItems() {
      // if the searchText is changng, more of less items may be visible in the table.
      // we need to update the selectedRows array to contain only the items that are still visible
      // first lets check if there are selected rows, which are not visible anymore
      console.log(this.selectedRows.length + ' / ' + this.$refs['allocationUnitsTable'].filteredItems.length);
      // then check if checkalltableentries is true, and if there are rows visible that are not checked, set checkalltableentries to false
      this.$refs['allocationUnitsTable'].filteredItems.find(x => {
        if (!x.checked) {
          console.log('Found unchecked item while filteredItems', x);
          this.checkedAllTableEntries = false;
          return true;
        }
      });
    },
    onCheckAllTableEntries() {
      /*
      this.isDeleteButtonEnabled = this.checkedAllTableEntries;
      this.allocationUnits.map(x => {
        return (x.checked = this.checkedAllTableEntries);
      });
      this.selectedRows = this.allocationUnits.filter(x => x.checked == true);
      */
      this.isDeleteButtonEnabled = this.checkedAllTableEntries;

      this.$refs['allocationUnitsTable'].filteredItems.map(x => {
        return (x.checked = this.checkedAllTableEntries);
      });
      this.selectedRows = this.allocationUnits.filter(x => x.checked == true);
    },

    onCheckedItemChange(item) {
      this.isDeleteButtonEnabled = false;
      this.selectedRows = this.allocationUnits.filter(x => x.checked == true);
      for (let i = 0; i < this.allocationUnits.length; i++) {
        if (this.allocationUnits[i].checked) {
          this.isDeleteButtonEnabled = true;
          break;
        }
      }
      if (!item.checked) {
        return (this.checkedAllTableEntries = false);
      }

      for (let i = 0; i < this.allocationUnits.length; i++) {
        if (!this.allocationUnits[i].checked) {
          return (this.checkedAllTableEntries = false);
        }
      }

      this.checkedAllTableEntries = true;
    },
    toggleRowEdit(item, fieldToFocus = null) {
      if (item && item.editMode && this.rowIsDirty) {
        return this.updateAllocationItem(this.rowIsDirty);
      }
      if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      // if clicking on another row, remove editMode from all rows that eventually were in editMore before
      for (const allocationUnit of this.allocationUnits.filter(x => x.editMode)) {
        allocationUnit.editMode = false;
      }

      this.rowIsDirty = null;
      if (!item) {
        this.visibleFields
          .filter(x => x.sortable !== null)
          .map(x => {
            x.sortable = !x.editMode;
            return x;
          });
        return;
      }

      item.editMode = !item.editMode;

      this.visibleFields
        .filter(x => x.sortable !== null)
        .map(x => {
          x.sortable = !item.editMode;
          return x;
        });

      if (item.editMode) {
        // we go into edit mode

        // create a backup of the current row's data. if the user cancels editing (esc, x-icon), revert to the backup
        this.rowDataBackup = { ...item };
        //console.log('zzz setting backup', this.rowDataBackup);
        this.$nextTick(() => {
          // if the user clicked on a specific field, then we focus on that field
          if (fieldToFocus) {
            this.$refs[fieldToFocus + '-' + item.DbId].focus();
          } else this.$refs['ordinalField-' + item.DbId].focus();
        });
      } else {
        item.Budget = parseFloat(item.Budget);
      }
    },
    cancelRowEdit(item) {
      console.log('zzz canceling', item, this.rowDataBackup);
      /*
      if (!item && this.rowDataBackup) {
        item = this.allocationUnits.find(x => x.DbId == this.rowDataBackup.DbId);
        console.log('zzz canceling setting item to backup', item);
      } else {
        console.log('zzz canceling nothing to cancel', item);
        return;
      }
      */
      item.editMode = false;
      this.visibleFields
        .filter(x => x.sortable !== null)
        .map(x => {
          x.sortable = !item.editMode;
          return x;
        });
      if (this.sortField)
        this.sortTableItemsBy(
          this.allocationUnits,
          this.sortField,
          this.sortDirection ? 'desc' : 'asc',
          this.sortField == 'BudgetSaldo' ? 'number' : null
        );
      // user has canceled editing, so revert value fields to the state, they had before editMode.
      console.log('zzz canceling resetting values', item);
      item.Ordinal = this.rowDataBackup.Ordinal;
      item.DisplayName = this.rowDataBackup.DisplayName;
      item.Budget = this.rowDataBackup.Budget;
      item.KGR = this.rowDataBackup.KGR;
      item.Responsible = this.rowDataBackup.Responsible;
      item.FA1 = this.rowDataBackup.FA1;
      item.FA2 = this.rowDataBackup.FA2;
      this.rowDataBackup = null;
    },
    insertNewRecord() {
      if (!this.$refs.newRecordRowForm.checkValidity()) {
        return this.$refs.newRecordRowForm.reportValidity();
      }
      // check if kke id or displayname already exists
      for (const item of this.allocationUnits) {
        if (item.Ordinal == this.rowDataNewRecord.Ordinal) {
          return this.$showError(
            this,
            'FEHLER: eine Vergabeeinheit mit der VE "' + item.Ordinal + '" existiert bereits.',
            'Vergabeeinheit anlegen'
          );
        }
        if (item.DisplayName == this.rowDataNewRecord.DisplayName)
          this.rowDataNewRecord.DisplayName = this.rowDataNewRecord.DisplayName + ' (1)';
      }
      this.rowDataNewRecord.NTR = this.settingsStore.settings['Nachtragsprozent'];
      this.rowDataNewRecord.Status = 1;
      this.rowDataNewRecord.ProcessStatus = 'offen';
      this.tableIsBusy = true;
      allocationUnitsService.createNewAllocationUnit(
        projectStore.activeProject.DbId,
        this.rowDataNewRecord,
        (err, result) => {
          this.tableIsBusy = false;
          if (err) {
            console.log('err', err);
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          } else {
            this.$showSuccess(this, 'Vergabeeinheit anlegen', 'Vergabeeinheit erfolgreich angelegt.');
            this.addNewAllocationUnit(result);
            this.rowDataNewRecord = {};
            this.$nextTick(() => {
              this.scrollToNewRecordRow(true);
            });
          }
        }
      );
    },
    addNewAllocationUnit(allocationUnit) {
      allocationUnit.editMode = false;
      this.allocationUnits.push(allocationUnit);
      this.recalcAllocationUnitsSum();
    },
    openSelectedRowItem(item) {
      this.navigateTo(item.DbId);
    },
    showImportVEModal() {
      this.$bvModal.show('ImportVEModal');
    },
    showCreateVEfromKKEDialog() {
      this.$bvModal.show('createFromKkeDialog');
    },
    createVEFromKKE(prefix) {
      this.tableIsBusy = true;
      allocationUnitsService
        .createFromCostGroups(prefix)
        .then(() => {
          this.loadAllocationUnits();
          this.$showSuccess(
            this,
            'Vergabeeinheiten aus KKE erstellen',
            'Vergabeeinheiten erfolgreich erstellt / aktualisiert.'
          );
        })
        .catch(err => {
          console.log(err.response ? err.response : err);
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.tableIsBusy = false;
        });
    },
    onWindowResize() {
      const totalHeight = window.innerHeight;
      const budgetSummarySection = this.$refs.budgetSummarySection;
      const headerHeight = this.$refs.pageHeader.offsetHeight;
      const tableHeight = totalHeight - headerHeight - budgetSummarySection.offsetHeight - 110;
      this.tableHeight = tableHeight + 'px';
    },
    clickEveryWhereHandler() {
      //console.log('zzz everywhere', event);
      //if (event.target && !event.target.classList.contains("table-input-field"))
      //this.cancelRowEdit();
    },
    filterRecords() {
      if (!this.filterToggle) {
        this.filterToggle = true;
        this.allocationUnitsBackup = [...this.allocationUnits];
        this.allocationUnits = this.allocationUnits.filter(x => {
          return x.checked == true;
        });
        this.checkedAllTableEntries = true;
      } else {
        this.filterToggle = false;
        this.allocationUnits = this.allocationUnitsBackup;
        this.checkedAllTableEntries = this.selectedRows.length == this.allocationUnits.length;
      }
      this.recalcAllocationUnitsSum(this.allocationUnits);
    }
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [
      this.$refs.allocationUnitsTable.$el.scrollTop,
      this.$refs.allocationUnitsTable.$el.scrollLeft
    ];
    next();
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    const that = this;
    window.addEventListener('keyup', function(e) {
      if (e.keyCode == 27) that.allocationUnits.forEach(x => (x.editMode = false));
    });
    this.allocationUnits = [];
    this.loadAllocationUnits();
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls
    this.onWindowResize();
    AppState.isLoading = false;
    if (this.settingsStore.settings['KGR_Selections_Active'] == 'false') {
      this.allocationUnitsFields.find(x => x.key == 'KGR').visible = false;
    } else {
      this.allocationUnitsFields.find(x => x.key == 'KGR').visible = true;
    }
    if (this.settingsStore.settings['Responsible_Selections_Active'] == 'false') {
      this.allocationUnitsFields.find(x => x.key == 'Responsible').visible = false;
    } else {
      this.allocationUnitsFields.find(x => x.key == 'Responsible').visible = true;
    }
    if (this.settingsStore.settings['FA1_Active'] == 'false') {
      this.allocationUnitsFields.find(x => x.key == 'FA1').visible = false;
    } else {
      this.allocationUnitsFields.find(x => x.key == 'FA1').visible = true;
    }
    if (this.settingsStore.settings['FA2_Active'] == 'false') {
      this.allocationUnitsFields.find(x => x.key == 'FA2').visible = false;
    } else {
      this.allocationUnitsFields.find(x => x.key == 'FA2').visible = true;
    }
    document.addEventListener('mousedown', this.clickEveryWhereHandler, true);
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
    document.removeEventListener('mousedown', this.clickEveryWhereHandler, true);
  },
  computed: {
    visibleFields() {
      return this.allocationUnitsFields.filter(field => field.visible);
    }
  }
};
</script>

<style scoped>
.page-header {
  border-bottom: 1px solid #dee2e6;
}
</style>
